export const frOthers = {
    'textField.noData': 'Aucune donnée',

    'state.filter.label': 'État',
    'commons.filters.title': 'Filtrer :',

    'validators.isRequired': 'Ce champ est requis',
    'validators.isNotUrl': 'Veuillez entrer un lien valide',
    'validators.isEmail': 'Ce champ doit être un email',
    'validators.isUndefinedOrGreaterThanZero': 'Ce champ ne peut pas être négatif',

    'validators.mustBeLessThan': 'Ce champ doit être plus petit que le champ "{field}"',
    'validators.mustBeGreatherThan': 'Ce champ doit être plus grand que le champ "{field}"',

    'page403.page.title': 'Non autorisé',
    'page403.message': "Vous n'avez pas les droits pour accèder à cette page",

    // OTHER LABELS

    'label.createdDate': 'Crée le',
    'label.published.at': 'Publié le',
    'label.finished.at': 'Terminé',
    'label.at': 'à',
    'import.excel.button.label': 'Import Excel',
    'import.excel.button.label.loading': 'Import en cours...',
    'export.excel.button.label': 'Export Excel',
    'export.excel.button.label.loading': 'Export en cours...',

    'edit.quit.confirmation':
        'Voulez-vous vraiment quitter ? Toutes vos modifications seront perdues.',

    'input.search.placeholder': 'Recherche',

    'image.picker.secondary.loading.message': "Chargement de l'image",
};
